export function getHeightStyleFromSeconds(seconds, secondsPerSection, pixelsPerSection) {
  // calc sections
  const sections = seconds / secondsPerSection;
  const pixels = sections * pixelsPerSection;

  return `${pixels}px`;
}
